import React, { createContext, useState, useEffect } from "react";
import io from "socket.io-client";

export const SocketContext = createContext();

const socketInstance = io({
  autoConnect: false,
});

export const SocketContextProvider = (props) => {
  const [socket, setSocket] = useState(socketInstance);
  const [user, setUser] = useState({});
  const [room, setRoom] = useState({});

  const addUserGameScore = (name, score, callback = null) => {
    socket.emit("recordGameScore", { name, score }, (response) => {
      if (response.error) console.error(response.error);
      if (typeof callback === "function") return callback(response);
    });
  };

  const joinRoom = (room, callback) => {
    socket.emit("joinRoom", { name: user.name, room }, (response) => {
      if (response.error) console.error(response.error);
      if (response.user) setUser(response.user);
      if (typeof callback === "function") return callback(response);
    });
  };

  const leaveRoom = (callback) => {
    socket.emit("leaveRoom", (response) => {
      if (response.error) console.error(response.error);
      setUser(response.user ?? {});
      setRoom({});
      if (typeof callback === "function") callback();
    });
  };

  const getRooms = (callback) => {
    socket.emit("getRooms", ({ rooms }) => {
      if (typeof callback === "function") {
        callback(Array.isArray(rooms) ? rooms : []);
      }
    });
  };

  useEffect(() => {
    if (socket.disconnected) {
      socket.connect();
    }

    socket.on("connect", () => {
      console.log("connected");
    });

    socket.on("disconnect", () => {
      console.log("disconnected");
      setUser({});
      setRoom({});
    });

    socket.on("roomData", ({ room, users }) => {
      console.log("roomData", { room, users });
      setRoom({ room, users });
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("ping");
    };
  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket,
        user,
        room,
        setSocket,
        setUser,
        setRoom,
        addUserGameScore,
        joinRoom,
        getRooms,
        leaveRoom,
      }}
    >
      {props.children}
    </SocketContext.Provider>
  );
};
